import { render, staticRenderFns } from "./dataView.vue?vue&type=template&id=5e80af2e&scoped=true&"
import script from "./dataView.vue?vue&type=script&lang=js&"
export * from "./dataView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e80af2e",
  null
  
)

component.options.__file = "dataView.vue"
export default component.exports